import { Collapse } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import { forwardRef, useImperativeHandle } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props, ref) => {
	const [opened, { open, close, toggle }] = useDisclosure(false)

	useImperativeHandle(
		ref,
		() => ({
			toggle: () => toggle(),
			expand: () => open(),
			collapse: () => close(),
		}),
		[opened]
	)

	return (
		<Collapse
			{...p}
			{...p.customProps}
			in={opened}
			onTransitionEnd={() => {
				sendOutput(p.noodlNode, 'state', opened)
				if (!opened) sendSignal(p.noodlNode, 'collapsed')
				else sendSignal(p.noodlNode, 'expanded')
			}}
		>
			{p.children}
		</Collapse>
	)
})
